import { jwtDecode } from "jwt-decode";
/**
 * Save JWT token in localStorage
 */
export const saveToken = (token) => {
	localStorage.setItem("token", token);
};

/**
 * Get JWT token from localStorage
 */
export const getToken = () => {
	return localStorage.getItem("token");
};

/**
 * Remove JWT token and logout the user
 */
export const logoutUser = () => {
	localStorage.removeItem("token");
	window.location.href = "/login"; // Redirect to login page
};

/**
 * Attach Authorization header for API requests
 */
export const getAuthHeaders = () => {
	const token = getToken();
	return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Get User DATA form Login Taoke
 */
export const getCurrentUser = () => {
  const token = getToken();
  if (!token) return null;

  try {
    return jwtDecode(token); // { roleID, userId, email, ... }
  } catch (err) {
    console.error("Invalid token:", err);
    return null;
  }
};

/**
 * Get current role(s) from token
 */

export const getCurrentRole = () => {
  const user = getCurrentUser();
  return user?.authorities || []; // array of role IDs
};